import { Store } from '@tanstack/store';

import type { Command } from './types';

interface CommandMenuState {
    isOpen: boolean;
    commands: Map<string, Command>;
}

const STORE_KEY = 'ingkaCommandMenuStore' as const;

declare global {
    var ingkaCommandMenuStore: Store<CommandMenuState> | undefined;
}

/**
 * Get or create the singleton command store.
 * Anchored on globalThis so that multiple bundles (micro-frontends)
 * share the same store instance on the same page.
 */
const getCommandStore = (): Store<CommandMenuState> => {
    const existing = globalThis[STORE_KEY];
    if (existing) {
        return existing;
    }

    const store = new Store<CommandMenuState>({ isOpen: false, commands: new Map() });
    globalThis[STORE_KEY] = store;
    return store;
};

export const commandStore = getCommandStore();
